/**
 * Cyber-Minimal AdSlot Component
 * 
 * @param {Object} props
 * @param {string} props.id - Ad ID
 * @param {string} props.label - Ad label (e.g., 'Advertisement')
 * @param {string} props.width - Ad width
 * @param {string} props.height - Ad height
 */
export function createAdSlot({ id, label = 'ADVERTISEMENT', width = '728px', height = '90px' }) {
  const container = document.createElement('div');
  container.className = 'cm-ad-slot';
  container.id = `ad-slot-${id}`;
  container.style.width = '100%';
  container.style.maxWidth = width;
  container.style.height = height;
  container.style.minHeight = height;
  
  const labelEl = document.createElement('div');
  labelEl.className = 'cm-ad-slot__label';
  labelEl.textContent = label;
  
  const placeholder = document.createElement('div');
  placeholder.className = 'cm-ad-slot__placeholder';
  placeholder.textContent = `${width} x ${height}`;
  
  container.appendChild(labelEl);
  container.appendChild(placeholder);
  
  return container;
}
